import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
import { baseUrl } from "@/config/env";
const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};

export const commerceGoodsSaleOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  saveBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "160",
  // menuType:'menu',
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "",
      prop: "jbxx",
      formsolt: true,
      type: "input",
      span: 13,
      hide: true,
    },
    {
      label: "产品名称",
      prop: "goodsName",
      formsolt: true,
      search: true,
      span: 24,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // {
    //     label: '产品型号',
    //     prop: 'type',
    //     type: "input"
    // },
    // {
    //     label: '产品单位',
    //     prop: 'unit',
    //     type: "input"
    // },
    {
      label: "产品一级分类",
      prop: "firstClassifyName",
      hide: true,
      viewVisdiplay: false,
      addVisdiplay: false,
      editVisdiplay: false,
      formsolt: true,
    },
    {
      label: "产品二级分类",
      prop: "secondClassifyName",
      hide: true,
      viewVisdiplay: false,
      addVisdiplay: false,
      editVisdiplay: false,
      formsolt: true,
    },
    {
      label: "SKU组合",
      prop: "sku",
      hide: true,
      viewVisdiplay: false,
      addVisdiplay: false,
      editVisdiplay: false,
      formsolt: true,
    },
    // {
    //     label: '推广员抽成类型',
    //     prop: 'promoteType',
    //     type: "select",
    //     dicData:DIC.PROMOTE_TYPE,
    //     placeholder:"请选择抽成类型"
    // },
    // {
    //     label: '推广员佣金/比例',
    //     prop: 'promote',
    //     type: "input",
    // },
    // {
    //     label: '产品库存',
    //     prop: 'repertoryNumber',
    //     type: "input",
    //     addVisdiplay: false,
    //     editVisdiplay: false
    // },
    // {
    //     label: '产品数量',
    //     prop: 'goodsNumber',
    //     type: "input",
    //     hide: true,
    // },
    // {
    //     label: '产品状态',
    //     prop: 'productStatus',
    //     solt: true,
    //     formsolt: true,
    //     //addVisdiplay:false
    // },

    // {
    //     label: '销售代理商',
    //     prop: 'agentId',
    //     hide: true,
    //     formsolt: true,
    // },

    {
      label: "产品价格",
      prop: "constitute",
      span: 24,
      solt: true,
      hide: true,
      formsolt: true,
    },
    {
      label: "价格名称",
      prop: "priceName",
      type: "input",
      formsolt: true,
      span: 12,
      hide: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "平台抽成比例",
      prop: "platformRatio",
      span: 12,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },

    // 上级推广员佣金类型
    {
      label: "上级佣金类型",
      prop: "parentCommissionRateType",
      span: 12,
      type: "select",
      formsolt: true,
      hide: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // 上级推广员佣金比例
    {
      label: "上级推广员佣金",
      prop: "parentCommissionRate",
      span: 12,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // 推广佣金类型
    {
      label: "推广员佣金类型",
      prop: "commissionRateType",
      span: 12,
      type: "select",
      formsolt: true,
      hide: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // 推广佣金比例
    {
      label: "推广员佣金",
      prop: "commissionRate",
      span: 12,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },

    {
      label: "",
      prop: "smps",
      formsolt: true,
      type: "input",
      span: 13,
      hide: true,
    },

    // {
    //     label: '省份',
    //     prop: 'province',
    //     type: 'select',
    //     cascader: ['city'],
    //     props: {
    //         label: 'name',
    //         value: 'id'
    //     },
    //     hide: true,
    //     span: 13,
    //     cascaderFirst: true,
    //     dicUrl: `${baseUrl}/joins-basic/v1/province`,
    //     dicData: 'province'
    // }, {
    //     label: '城市',
    //     prop: 'city',
    //     type: 'select',
    //     cascader: ['area'],
    //     props: {
    //         label: 'name',
    //         value: 'id'
    //     },
    //     // dicFlag: false,
    //     // cascaderFirst: true,
    //     span: 13,
    //     hide: true,
    //     dicUrl: `${baseUrl}/joins-basic/v1/province/citys/{{key}}`,
    //     dicData: 'city'
    // }, {
    //     label: '地区',
    //     prop: 'area',
    //     type: 'select',
    //     props: {
    //         label: 'name',
    //         value: 'id'
    //     },
    //     // dicFlag: false,
    //     // cascaderFirst: true,
    //     span: 13,
    //     hide: true,
    //     dicUrl: `${baseUrl}/joins-basic/v1/province/areas/{{key}}`,
    //     dicData: 'area'
    // },
    {
      label: "省份",
      prop: "province",
      type: "select",
      hide: true,
      formsolt: true,
    },
    {
      label: "城市",
      prop: "city",
      type: "select",
      hide: true,
      formsolt: true,
    },
    {
      label: "地区",
      prop: "area",
      type: "select",
      hide: true,
      formsolt: true,
    },
    {
      label: "配送方式",
      prop: "dispatching",
      hide: true,
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "配送费比例",
      prop: "distributionFee",
      hide: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "",
      prop: "spgl",
      formsolt: true,
      type: "input",
      span: 13,
      hide: true,
    },
    {
      label: "服务类目",
      prop: "joinsWorkServiceCategory",
      hide: true,
      solt: true,
      formsolt: true,
    },
    {
      label: "服务项目",
      prop: "joinsWorkServiceItem",
      solt: true,
      hide: true,
      formsolt: true,
    },
    {
      label: "优惠券",
      prop: "coupon",
      solt: true,
      hide: true,
      formsolt: true,
    },
    {
      label: "",
      prop: "xxtx",
      formsolt: true,
      type: "input",
      span: 13,
      hide: true,
    },
    {
      label: "提醒人员",
      prop: "notifyStaffs",
      formsolt: true,
      type: "select",
      span: 13,
      hide: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // {
    //     label: "描述图片",
    //     prop: "describeImgs",
    //     span: 24,
    //     hide: true,
    //     solt: true,
    //     formsolt: true
    // }, {
    //     label: "轮播图片",
    //     prop: "wheelsImgs",
    //     span: 24,
    //     solt: true,
    //     hide: true,
    //     formsolt: true
    // },
    {
      label: "售卖状态",
      prop: "status",
      dicData: DIC.PRODUCT_GOODS_STATUS,
      type: "select",
      search: true,
      editVisdiplay: false,
      addVisdiplay: false,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // {
    //     label: '更新人',
    //     prop: 'updateBy',
    //     addVisdiplay: false,
    //     editVisdiplay: false
    // }
    // ,
  ],
};
